import { h } from "preact";
import { Container,Tree, TreeItem } from "uitoolkit";
import { useEffect } from "preact/hooks";
import { ensureGlobalUserDataItems, globalUserData } from "../../state/userdata";
import { ContentItemType } from "../../graphql/types";
import { BackendContentItem } from "services/backend";
import { route } from "preact-router";

export function RecentSidepanel(props: {
    conversationId: string | null,
    onMessageSelected?: (id: string) => void,
}) {
    const ready = !!globalUserData.value.starredItems;
    const starredItems = globalUserData.value.starredItems ?? [];
    const recentItems = globalUserData.value.recentItems ?? [];

    function mapItem(item: BackendContentItem) {
        return (
            <TreeItem
                icon={item.type == ContentItemType.Chat ? "teams-chat" : "markdown"}
                label={item.title || "Untitled"}
                class={item.id == props.conversationId ? "bold" : undefined}
                onItemClicked={() => {
                    if(item.type == ContentItemType.Chat) {
                        props.onMessageSelected?.(item.id!);
                    } else {
                        route("/note/" + item.id);
                    }
                }}
            />
        );
    }

    useEffect(() => {
        ensureGlobalUserDataItems();
    }, []);

    return (
        <Container class="column sidebar dividerleft noprint">
            <div class="sidebarheader">Content</div>
            <Container class="overflow-y-auto overflow-x-hidden scrollbar-gutter-stable">
                <Tree>
                    <TreeItem chevron="chevron-down" label="Starred" class="inactive">
                        {
                            starredItems.map(mapItem)
                        }
                        {
                            ready && starredItems.length == 0 &&
                            <div style={{ opacity: 0.5 }}>There are no starred conversations</div>
                        }
                    </TreeItem>
                    <TreeItem chevron="chevron-down" label="Recent" class="inactive">
                        {
                            recentItems.map(mapItem)
                        }
                        {
                            ready && recentItems.length == 0 &&
                            <div style={{ opacity: 0.5 }}>There are no recent conversations</div>
                        }
                    </TreeItem>
                </Tree>
            </Container>
        </Container>
    );
}